<template>
  <div class="contain">
    <van-popup
      v-model="isShow"
      position="bottom"
      :style="{ height: '70%' }"
      @click-overlay="onClose"
      :close-on-click-overlay="false"
    >
      <div class="search-box">
        <van-search placeholder="请输关键字搜索" v-model="keywords" @input="onSearch" />
      </div>
      <div style="height:44px"></div>
      <div class="user-box">
        <div class="add-item" @click="memberAdd"  >
          新增运动员
        </div>
        <van-cell-group v-if="options.length>0">
            <van-cell
              v-for="(item, index) in options"
              clickable
              :label="(item.sex==1? '男':'女')+' '+item.num"
              :key="index"
              @click="toggle(item)"
              :v-if="index < limit"
            >
              <template slot="title">
                <div class="custom-title">{{item.name}}</div>
              </template>
              <van-checkbox
                v-model="item.checked"
                slot="right-icon"
                checked-color="#FD2840"
              />
            </van-cell>
          </van-cell-group>
        <div v-else class="noresult">
          没有记录...
        </div>
      </div>
      <div class="createbtn">
        <van-button type="danger" v-if="options.length==0 && !keywords"  native-type="button" size="large" v-rblink="{name:'YundongyuanList'}">新增运动员</van-button>
        <van-button type="danger" v-else native-type="button" size="large" @click="onConfirm">确定</van-button>
      </div>

      <van-popup
              position="bottom"
              :style="{ height: '60%' }"
              v-model="addShow"
              @click-overlay="addShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
          >
            <van-divider>新增运动员</van-divider>
            <van-cell-group>
              <van-field
                      v-model="formData.name"
                      label="姓名"
                      :rules="[{ required: true, message: '姓名不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入姓名"
              />
              <van-field
                      readonly
                      clickable
                      right-icon="arrow"
                      input-align="right"
                      @click="showNumTypePicker=true"
                      label="证件类型"
                      v-model="formData.numTypeName"
              />
              <van-popup v-model="showNumTypePicker" position="bottom">
                <van-picker :columns="numTypeColumns"
                            show-toolbar
                            :default-index="formData.cardtype-1"
                            @cancel="showNumTypePicker = false"
                            @confirm="onNumTypeConfirm"
                />
              </van-popup>



              <van-field
                      v-if="formData.cardtype==1"
                      v-model="formData.num"
                      :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                      error-message-align="right"
                      label="身份证号"
                      input-align="right"
                      clearable
                      placeholder="请输入身份证号"
              />

              <van-field
                      v-model="formData.huzhao"
                      v-if="formData.cardtype!=1"
                      label="证件号码"
                      :rules="[{ required: true, message: '证件号码不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入证件号码"
              />

              <van-field
                      v-if="showBirthday"
                      readonly
                      clickable
                      label="生日"
                      input-align="right"
                      error-message-align="right"
                      placeholder="请选择生日"
                      v-model="formData.birthday"
                      :rules="[{ required: true, message: '请选择生日' }]"
                      @click="showDate = true" />

              <van-popup v-model="showDate" position="bottom">

                <van-datetime-picker
                        type="date"
                        title="选择年月日"
                        v-model="currentDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="onDateConfirm"
                        @cancel="showDate=false"
                />
              </van-popup>


              <van-field
                      v-if="showSex"
                      name="radio" label="性别"
                      input-align="right">
                <template #input>
                  <van-radio-group v-model="formData.sex" direction="horizontal">
                    <van-radio checked-color="#ffb01b" :name="1">男</van-radio>
                    <van-radio checked-color="#ffb01b" :name="2">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>


              <van-field
                      v-if="showJianhu"
                      v-model="formData.jianhuname"
                      label="监护人姓名"
                      :rules="[{ required: true, message: '监护人姓名不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入监护人姓名"
              />

              <van-field
                      v-if="showJianhu"
                      v-model="formData.jianhunum"
                      label="监护人证件号码"
                      :rules="[{ required: true, message: '监护人证件号码不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入监护人证件号码"
              />

              <van-field
                      v-model="formData.jianhuphone"
                      label="监护人手机"
                      :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入监护人手机"
              />


            </van-cell-group>

            <div class="savebtn">
              <van-button
                      color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                      style="width: 3rem"
                      size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." native-type="submit" >保存</van-button>
            </div>
          </van-form>
        </div>
      </van-popup>


    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import validator from "../../utils/validator";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  DatetimePicker,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(DatetimePicker);

export default {
  name: "YundongyuanPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    danweiId: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      validator,
      showDate: false,
      isShow: false,
      result: [],
      addShow:false,
      list:[],
      keywords: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker:false,
      numTypeColumns: ['身份证', '护照','其他身份证明'],
      actions:[
        { name: '隐藏' },
        { name: '认证' },
      ],
      formData:{
        name:'',
        num:'',
        huzhao:'',
        cardtype:1,
        birthday:'',
        sex:1,
        numTypeName:'身份证',
        jianhuname:'',
        jianhunum:'',
        jianhuphone:'',
      },
      saveLoading:false,

    };
  },
  mounted() {
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.num) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.num
      })
    },


    showBirthday(){
      return this.formData.cardtype !=1 ;
    },
    showSex(){
      return this.formData.cardtype !=1 ;
    },
    showJianhu(){
      return this.formData.cardtype !=1 || (item =>{
                if(this.formData.num.trim().length==18){
                  var year   = Number(this.formData.num.trim() .substr(6,4));
                  var curYear= new Date().getFullYear();
                  if(curYear - year  < 18){
                    return true
                  }
                }
              })();
    }
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },


    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.num != item.num
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
              "/api/yundongyuan/yundongyuanOptions",
              { keywords: this.keywords },
        res => {
          that.list = [...res.data];
        }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    },

    memberAdd(){
      this.addShow = true;
    },


    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      this.formData.birthday =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onNumTypeConfirm(value, index){
      this.formData.numTypeName = value;
      this.formData.cardtype = index+1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },
    onSubmit(values){
      console.log('onSubmit-values',values);
      console.log('submitType',this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onSearch();
        that.formData = {
          name:'',
          num:'',
          huzhao:'',
          cardtype:1,
          birthday:'',
          sex:1,
          numTypeName:'身份证',
          jianhuname:'',
          jianhunum:'',
          jianhuphone:'',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
  }
};
</script>

<style scoped>
  .add-item{position: relative;/*padding: 10px 18px;*/padding: 15px 18px;color: #4A90E2;font-size: 14px;}
  .add-item:after{ content: ''; position: absolute; left: 0; right: 0; bottom: 0; border-bottom: 1px solid #d9d9d9; transform: scaleY(0.5); }

  .noresult{
    text-align: center;
    color: #666;
    padding-top: 1rem;
  }
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}


  .savebtn {
    position: fixed;
    bottom: 0;
    padding-bottom: 0.2rem;
    width: 100%;
    z-index: 10;
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-around;
    background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
  }
</style>


// WEBPACK FOOTER //
// YundongyuanPicker.vue?9eccd7b2